import { render, staticRenderFns } from "./RequestACard.vue?vue&type=template&id=8b3f346c&scoped=true"
import script from "./RequestACard.vue?vue&type=script&lang=js"
export * from "./RequestACard.vue?vue&type=script&lang=js"
import style0 from "./RequestACard.vue?vue&type=style&index=0&id=8b3f346c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3f346c",
  null
  
)

export default component.exports